import React, { useEffect } from "react";
import { t } from "i18next";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { CartAction } from "store/actions";
import * as ROUTE_CONSTANTS from "routes/constants";
import { useCustomHistory } from "hooks";
import { calculateCartGrossAmount } from "utils/Utils";
import C from "Constants";
import useCurrentUser from "hooks/useCurrentUser";
import { FixedFooter } from "components";
import { TranslationText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";
import { CustomButton } from "components/Button";
function BasketFooterOverview() {
  //hooks
  const params = useParams();
  const dispatch = useDispatch();
  const router = useCustomHistory();
  //global state
  const { outletBasedSelectedStoreArea } = useSelector((state) => state?.store);
  const { currentUser } = useCurrentUser();

  const { cart, cartTotal, orderGrossAmount } = useSelector((state) => state?.cart);
  const { discountInfo } = useSelector((state) => state?.Discounts);
  const { DomainType, orderType } = useSelector((state) => state.AppReducer);

  //redirect to login page
  const redirectToPage = () => {
    let url = ROUTE_CONSTANTS.OUTLET_CHECKOUT[1];
    let url2 = ROUTE_CONSTANTS.OUTLET_LOGIN[1];
    if (currentUser?.token) {
      router(url, `/${params.domainName}${url}`, DomainType);
    } else {
      router(url2, `/${params.domainName}${url2}`, DomainType);
    }
  };

  useEffect(() => {
    const { itemsGrossAmount, itemsNetPrice, orderGrossAmount } =
      calculateCartGrossAmount(cart, discountInfo);
    dispatch(
      CartAction.updateCartPrice({
        originalPrice: itemsNetPrice,
        amountAfterDiscount: itemsGrossAmount,
        itemsGrossAmount,
        orderGrossAmount,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  //get value
  const getValue = () => {
    const orderValue = outletBasedSelectedStoreArea?.minOrder - cartTotal;
    return orderValue >= 0 ? orderValue?.toFixed(2) : 0;
  };

  const gotoStorePage = () =>
    router(
      `/store/store-detail`,
      `/${params?.domainName}/store/store-detail`,
      DomainType
    );

  if(cart?.length <= 0) return null;

  return (
    <FixedFooter
      containerStyleProps={{ className: "dummy-class" }}
      innerStyleProps={{ className: "bg-dark-blue-100 p-4 ", style:{
        height: "auto"
      } }}
      page={true}
    >
      <div className="flex justify-between items-center text-16x w-full font-bold">
        <TranslationText text="Total (inc. Tax)" />
        <PriceRender
          price={orderGrossAmount}
          className="dummy-class leading-none"
        />
      </div>
      <hr className="border-t-2 w-full my-4" />
      <CustomButton
        className="w-full flex gap-1 flex-wrap items-center justify-center"
        onClick={
          outletBasedSelectedStoreArea?.minOrder > cartTotal &&
          orderType?.EN?.name === C.SERVICE_TYPE.DELIVERY
            ? () => gotoStorePage()
            : () => redirectToPage()
        }
      >
        <TranslationText
          text={
            outletBasedSelectedStoreArea?.minOrder > cartTotal &&
            orderType?.EN?.name === C.SERVICE_TYPE.DELIVERY
              ? "Add"
              : "Review Order"
          }
          className="text-white"
        />
        {
          outletBasedSelectedStoreArea?.minOrder > cartTotal &&
          orderType?.EN?.name === C.SERVICE_TYPE.DELIVERY && 
          <>
          <PriceRender price={+getValue()} className="text-white" currencySymbolClassName="text-white" />
          <TranslationText text="more" className="text-white" />
          </>
        }
      </CustomButton>
    </FixedFooter>
  );
}

export default BasketFooterOverview;
